<template>
  <div>
    <div v-if="entries && entries.length > 0">
      <div v-if="winners.length > 0">
        <table>
        <thead>
          <tr>
            <th>Winning User</th>
            <th># Of Tickets</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in winners" v-bind:key="entry.user_id + entry.quantity.toString()">
            <td data-title="User"><User :user_id="entry.user_id"></User></td>
            <td data-title="Amount">{{formatCurrency(entry.quantity)+` (${(entry.quantity/ticketRaffle.total_entries).toFixed(4)*100}%)`}}</td>
          </tr>
        </tbody>
        </table>
      </div>
      <!-- Table starts here -->
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th># Of Tickets</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in entries" v-bind:class="index % 2 ? 'pp-odd' : 'pp-even'" v-bind:key="entry.user_id + entry.quantity.toString()">
            <td data-title="User"><User :user_id="entry.user_id"></User></td>
            <td data-title="Amount">{{formatCurrency(entry.quantity)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>No entries</div>  

  </div>
</template>

<script>
// import { mapState } from 'vuex'

export default {
  name: 'ticket-raffle-entries',
  props: ['ticketRaffleId', 'ticketRaffle'],
  async created () {
    this.refreshEntries()
  },
  data () {
    return {
    }
  },
  computed: {
    entries () {
      // console.log('STORE', this.$store.state.placedBets)
      return (this.$store.state.ticketRaffleEntries[this.ticketRaffleId] || [])
    },
    winners () {
      return (this.$store.state.ticketRaffleWinners[this.ticketRaffleId] || [])
    }
  },
  methods: {
    async refreshEntries () {
      return this.$store.dispatch('fetchTicketRaffleEntries', this.ticketRaffleId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0px;
    }
    tbody tr:nth-child(even){
        background-color: rgba(0, 0, 0, 0.3);
    }
    tbody tr:nth-child(odd){
        background-color: rgba(0, 0, 0, 0.2);
    }
    table tr{
        height: 40px;
        transition: background-color 0.2s ;
    }
    tbody tr:hover{
        background-color: rgba(0, 0, 0, 0.5);
    }
    thead{
        background-color:#b62626;
        font-weight: bold;
        font-size: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Ticket-Raffle-Entries.vue